import React, { useId } from "react";

import { Input } from "@workspace/web-ui/components/input";
import { Label } from "@workspace/web-ui/components/label";
import { cn } from "@workspace/web-ui/lib/utils";

export interface RadioProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  value: string;
  name: string;
  checked?: boolean;
  autoFocus?: boolean;
  inputVisible?: boolean;
  error?: boolean;
}

const RadioOption = React.forwardRef<HTMLInputElement, RadioProps>(
  (
    { className, error, label, checked, inputVisible, ...props },
    ref,
  ) => {
    const id = useId();

    return (
      <>
        <Label
          htmlFor={id}
          className={cn(
            "flex w-full !py-[12px] cursor-pointer shadow flex-row-reverse items-center justify-between rounded-[16px] border-[1px] border-solid p-[16px] transition-colors duration-300 ease-in-out",
            " gap-[12px]",
            " md:gap-[16px] md:p-[20px]",
            " lg:gap-[24px] lg:p-[20px]",
            checked ? "border-[#4272DD]" : "border-[rgba(0,0,0,0.1)]",
            error ? "border-destructive" : null,
          )}
        >
          <Input
            type="radio"
            ref={ref}
            {...props}
            id={id}
            className={cn("peer mr-2 p-3 w-3 !py-2 text-blue-500 focus:ring-blue-500 md:w-3.5 lg:p-3 lg:w-4", className)}
            checked={checked}
            input-visible={`${inputVisible ? "true" : "false"}`}
          />
          <p className="text-left text-base text-[#7F8493] transition-colors duration-200 ease-in-out peer-checked:text-[#363840] md:text-lg">
            {label}
          </p>
        </Label>
        {/* <p className="text-right text-sm font-medium text-destructive sm:text-base">
          {error && error.message}
        </p> */}
      </>
    );
  },
);

RadioOption.displayName = "RadioOption";

export { RadioOption };
